<template>
  <b-sidebar
    id="add-new-user-sidebar"
    ref="sideBar"
    :visible="isActive"
    backdrop
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    bg-variant="white"
    right
    shadow
    sidebar-class="sidebar-lg"
    header-class="content-sidebar-header"
    footer-class="content-sidebar-footer"
    @change="(val) => $emit('update:is-active', val)"
  >
    <template #header="{hide}">
      <div class="d-flex justify-content-between align-items-center w-100">
        <h5 class="mb-0">
          {{ isUpdateParticipants ? 'Atualizar Participantes' : 'Importar arquivo' }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer float-right"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
    </template>
    <template #footer="{hide}">
      <div class="p-1">
        <b-row>
          <b-col
            sm="12"
            md="12"
            class="text-right"
          >

            <!-- Form Actions -->
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="button"
              class="mr-2"
              @click="onSubmit"
            >
              <feather-icon
                icon="SaveIcon"
                class="mr-50"
              />
              Salvar
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-danger"
              type="button"
              @click="onCancel"
            >

              <font-awesome-icon
                prefix="far"
                :icon="['far', 'times-circle']"
                class="mr-50"
              />
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </div>
    </template>
    <template #default="{ hide }">
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
        >
          <label for="file">Arquivo: (csv)</label>
          <b-form-file
            id="file"
            v-model="model.file"
            accept=".csv"
          />
          <download-helper v-if="isUpdateParticipants" :full-url="updateFileExample" :validate-format="true" :valid-formats="validFormats" />
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { alphaNum, required } from '@validations'
import { ValidationObserver } from 'vee-validate'
import DownloadHelper from '@/components/app/global/DownloadHelper.vue'

import { PrizeDrawService } from '../../services/prize-draws.service'
import { ParticipantService } from '../../services/participants.service'

export default {
  name: 'PrizeDrawFileImport',
  directives: {
    Ripple,
  },
  components: {
    DownloadHelper,
    ValidationObserver,
  },
  props: {
    prizeDraw: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    isUpdateParticipants: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      promotionsAvailable: [],
      model: {
        file: [],
      },
      validFormats: ['text/csv', 'application/csv', 'application/vnd.ms-excel'],
      updateFileExample: `${process.env.VUE_APP_URL}/file-examples/atualizacao_participante.csv`,
    }
  },
  methods: {
    async onSubmit() {
      if (this.isUpdateParticipants) {
        await this.handleParticipantUpdate()
        return
      }

      const isValid = await this.$refs.refFormObserver.validate()
      if (!isValid) return

      await this.handleStandardImport()
    },

    async handleStandardImport() {
      const canImport = this.prizeDraw.promotion.settings.can_import_file
      const response = await PrizeDrawService.importFile(
        this.prizeDraw.uuid,
        canImport,
        this.model.file,
      )

      this.cleanForm()

      if (response && response.error_message) {
        this.$notify.error(response.error_message)
        return
      }

      this.$notify.success(response.message || 'Importado com sucesso!')
      this.$emit('onModelSave', true)
    },

    async handleParticipantUpdate() {
      const response = await ParticipantService.updateViaFile(this.model.file)

      this.cleanForm()

      if (response && response.error_message) {
        this.$notify.error(response.error_message)
        return
      }

      this.$notify.success(response.message || 'Participantes atualizados!')
      this.$emit('onModelSave', true)
    },

    cleanForm() {
      this.model.file = null
      this.$refs.refFormObserver.reset()
    },

    onCancel() {
      this.$emit('onCancel', true)
      this.$refs.refFormObserver.reset()
    },
  },
}
</script>

<style scoped>

</style>
